module.exports = __webpack_public_path__ + "static/img/MRI_3.54365b78.jpg";